import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3bf3ff8a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "padding-16"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "hot-articles-introduce"
};
const _hoisted_4 = {
  class: "hot-articles-title"
};
const _hoisted_5 = {
  style: {
    "color": "#888"
  }
};
import ModuleCard from "@/views/college/components/ModuleCard.vue";
import { Refresh } from '@element-plus/icons-vue';
import { reactive, ref } from "vue";
import { College } from "@/api/college";
import { useRouter } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendArticle',
  setup(__props) {
    const router = useRouter();
    const params = reactive({
      pageNo: 1,
      pageSize: 6
    });
    const articles = ref([]);
    const total = ref(0);
    const getArticles = async (init = true) => {
      const res = await College.recommend(params);
      articles.value = res.data.list;
      init && (total.value = res.data.total);
    };
    getArticles();
    const changPage = async () => {
      //如切换页码时请求加载的数据量超过全部数据量，从第一页开始加载
      params.pageNo++;
      if (params.pageNo * 6 - total.value >= 6) {
        params.pageNo = 1;
      }
      await getArticles(false);
    };
    //跳转详情
    const toDetail = val => {
      router.push({
        name: 'zixunDetail',
        params: {
          id: val.id
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_image = _resolveComponent("el-image");
      return articles.value.length ? (_openBlock(), _createBlock(ModuleCard, {
        key: 0,
        title: "推荐资讯"
      }, {
        "title-right": _withCtx(() => [total.value > 6 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          link: "",
          type: "primary",
          icon: _unref(Refresh),
          onClick: changPage
        }, {
          default: _withCtx(() => [_createTextVNode("换一换")]),
          _: 1
        }, 8, ["icon"])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articles.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item,
            class: "hot-articles-card",
            onClick: $event => toDetail(item)
          }, [_createVNode(_component_el_image, {
            src: item.coverId,
            class: "hot-articles-img",
            fit: "cover"
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(item.publishTime), 1)])], 8, _hoisted_2);
        }), 128))])]),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});